/* =========================================================
   BBQ RESCHER – CART AGREEMENT GUARD
   Globaler, jQuery-unabhängiger Checkout-Schutz.

   Ergänzt die bestehende Legacy-Logik, ohne Texte oder die
   rechtliche Bedeutung der Checkboxen zu verändern.
   ========================================================= */

(function () {
  'use strict';

  if (window.BBQRCartAgreementGuard) return;

  function getCheckoutTrigger(target) {
    if (!target || !target.closest) return null;

    return target.closest(
      '[name="checkout"], [name="goto_pp"], [name="goto_gc"]'
    );
  }

  function getUncheckedAgreement() {
    var agreementIds = ['agree_agb', 'agree_widerruf'];

    for (var index = 0; index < agreementIds.length; index += 1) {
      var checkbox = document.getElementById(agreementIds[index]);

      if (checkbox && !checkbox.checked) {
        return checkbox;
      }
    }

    return null;
  }

  document.addEventListener('click', function (event) {
    var checkoutTrigger = getCheckoutTrigger(event.target);

    if (!checkoutTrigger) return;

    var uncheckedAgreement = getUncheckedAgreement();

    if (!uncheckedAgreement) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    window.alert(
      'Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.'
    );

    uncheckedAgreement.focus();
  }, true);

  window.BBQRCartAgreementGuard = true;
}());
